import { SupplierDetailsDto, SupplierDetailsDtoRefOrgInfoSourceEnum } from "lib/generated/app-api";
import { SupplierFromQuery } from "lib/hooks/api/supplier/useSupplierDetailsGql";

/**
 * Maps GraphQL reference organization source to legacy enum
 */
function mapSourceToLegacyEnum(source: string): SupplierDetailsDtoRefOrgInfoSourceEnum {
  switch (source) {
    case "oscar":
      return SupplierDetailsDtoRefOrgInfoSourceEnum.Oscar;
    case "companies_house":
      return SupplierDetailsDtoRefOrgInfoSourceEnum.CompaniesHouse;
    case "dun_and_bradstreet":
      return SupplierDetailsDtoRefOrgInfoSourceEnum.DunAndBradstreet;
    default:
      // Fallback to Oscar if unknown source
      return SupplierDetailsDtoRefOrgInfoSourceEnum.Oscar;
  }
}

/**
 * Maps GraphQL supplier data to the legacy SupplierDetailsDto format
 * This utility helps maintain compatibility with existing components
 * while using the new GraphQL API
 */
export function mapGraphQLSupplierToLegacyFormat(supplier: SupplierFromQuery): SupplierDetailsDto {
  return {
    id: supplier.id,
    guid: supplier.guid,
    name: supplier.name,
    country: supplier.country || "Unknown",
    isSme: supplier.isSme || false,
    address: {
      address: supplier.address || "",
      town: supplier.town || "",
      postCode: supplier.postalCode || "",
      countryCode: supplier.countryCode || "",
    },
    referenceOrganisations:
      supplier.referenceOrganisations?.map((refOrg) => ({
        name: refOrg.name,
        source: mapSourceToLegacyEnum(refOrg.source),
        sourceIdentifier: refOrg.sourceIdentifier,
        address: {
          address: refOrg.address?.address || "",
          address2: refOrg.address?.address2 || "",
          postCode: refOrg.address?.postCode || "",
          countryCode: refOrg.address?.countryCode || "",
        },
        basicContactInfo: {
          phone: refOrg.basicContactInfo?.phone || "",
          websiteUrl: refOrg.basicContactInfo?.websiteUrl || "",
        },
      })) || [],
  };
}
